import { ToggleItem } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/periodSelector/components/toggleItem/ToggleItem'

import periodStyles from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/periodSelector/PeriodSelector.module.scss'

const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']
const noop = () => undefined

export const ReadOnlyPeriodSelector = ({ period }: { period?: string | null }) => {
  const selectedQuarters = new Set(period?.split(',').map((quarter) => quarter.trim()) ?? [])

  return (
    <div className={periodStyles.root}>
      <div className={periodStyles.quartersContainer}>
        {QUARTERS.map((quarter) => (
          <ToggleItem
            key={quarter}
            buttonClassName={periodStyles.quarterButton}
            value={quarter}
            isActive={selectedQuarters.has(quarter)}
            isDisabled
            onClick={noop}
          />
        ))}
      </div>
    </div>
  )
}
